<div
	class="d-flex flex-row flex-nowrap h-100"
	[ngClass]="['justify-content-' + horizontalPosition, 'align-items-' + verticalPosition]"
>
	<ng-content></ng-content>
</div>
